import { render, staticRenderFns } from "./BadgeCollection.vue?vue&type=template&id=65821847&scoped=true"
import script from "./BadgeCollection.vue?vue&type=script&lang=js"
export * from "./BadgeCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65821847",
  null
  
)

export default component.exports